(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mqWide = matchMedia('(min-width: 900px)');
  var isWide = function () { return mqWide.matches; };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
  var HEADER = 56;

  var state = { gender: 'Men', size: null, variantId: null, img: 0, cart: 0, sizeError: false, sticky: false, added: false, adding: false };
  function listFrom(el, attr, fallback) {
    var raw = el && el.getAttribute(attr);
    if (!raw) return fallback;
    var parts = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    return parts.length ? parts : fallback;
  }
  var sizeGridEl = $('#sizeGrid');
  var sizeSets = {
    Men: listFrom(sizeGridEl, 'data-men', ['UK6', 'UK7', 'UK8', 'UK9', 'UK10', 'UK11']),
    Women: listFrom(sizeGridEl, 'data-women', ['UK3', 'UK4', 'UK5', 'UK6', 'UK7', 'UK8'])
  };
  var letterNodes = $$('[data-letter]');
  var letterCaps = letterNodes.length ? letterNodes.map(function (el) { return el.getAttribute('data-cap') || ''; }) : ['Sealed', 'The moodboard', 'The anatomy'];

  /* ---------- Intro bars ---------- */
  var easeIO = 'cubic-bezier(.77,0,.18,1)';
  ['#barTop', '#barBot'].forEach(function (sel) {
    var b = $(sel); if (!b) return;
    if (reduce) { b.style.height = '0'; return; }
    b.style.transition = 'height 1100ms ' + easeIO + ' 150ms';
    requestAnimationFrame(function () { requestAnimationFrame(function () { b.style.height = '0'; }); });
  });

  /* ---------- Reveal on scroll ---------- */
  function setupReveal() {
    if (reduce) return;
    var els = $$('[data-reveal]');
    var ease = 'cubic-bezier(.16,1,.3,1)';
    els.forEach(function (el) {
      var t = el.dataset.reveal, d = +(el.dataset.delay || 0);
      el.style.transition = 'opacity 1200ms ' + ease + ' ' + d + 'ms, transform 1300ms ' + ease + ' ' + d + 'ms, filter 1400ms ' + ease + ' ' + d + 'ms, clip-path 1400ms ' + ease + ' ' + d + 'ms';
      if (t === 'blur') { el.style.opacity = '0'; el.style.filter = 'blur(10px)'; }
      if (t === 'up') { el.style.opacity = '0'; el.style.transform = 'translateY(40px)'; }
      if (t === 'line') { el.style.transform = 'translateY(110%)'; }
      if (t === 'img') { el.style.clipPath = 'inset(18% 0 0 0)'; el.style.transform = 'translateY(32px)'; }
      if (t === 'still') { el.style.opacity = '0'; el.style.transform = 'scale(1.25)'; el.style.filter = 'blur(12px)'; }
    });
    var map = new Map();
    els.forEach(function (el) {
      var t = el.dataset.reveal === 'line' ? el.parentElement : el;
      if (!map.has(t)) map.set(t, []);
      map.get(t).push(el);
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        (map.get(e.target) || []).forEach(function (el) { el.style.opacity = ''; el.style.transform = ''; el.style.filter = ''; el.style.clipPath = ''; });
        io.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    requestAnimationFrame(function () { map.forEach(function (_, t) { io.observe(t); }); });
  }

  /* ---------- Morphing headline ---------- */
  function startMorph() {
    var el = $('#morph'); if (!el) return;
    var texts = (el.getAttribute('data-phrases') || 'What we wear|What we eat,|What we make|How we gather.').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!texts.length) texts = ['What we wear'];
    var a = $('[data-m="1"]', el), b = $('[data-m="2"]', el);
    var hl = function (s) { return s.replace(/(\S+?)([.,]?)$/, '<span style="color:#C3001A">$1</span>$2'); };
    var paint = function (node, s) {
      node.innerHTML = '<span style="display:block; text-align:center; white-space:nowrap;">' + hl(s) + '</span>';
    };
    paint(b, texts[0]);
    paint(a, texts[1] || texts[0]);
    var idx = 0, morph = 0, cool = 0.9, last = performance.now(), vis = false, nText = texts.length;
    var MT = 0.7, CT = 0.9;
    if (reduce) {
      el.style.filter = 'none';
      setInterval(function () { idx = (idx + 1) % texts.length; paint(b, texts[idx]); }, 1600);
      return;
    }
    new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: 0 }).observe(el);
    function set(f) {
      b.style.filter = 'blur(' + Math.min(8 / f - 8, 100) + 'px)'; b.style.opacity = (Math.pow(f, .4) * 100) + '%';
      var g = 1 - f;
      a.style.filter = 'blur(' + Math.min(8 / g - 8, 100) + 'px)'; a.style.opacity = (Math.pow(g, .4) * 100) + '%';
      var n1 = texts[idx % nText], n2 = texts[(idx + 1) % nText];
      if (a.dataset.t !== n1) { paint(a, n1); a.dataset.t = n1; }
      if (b.dataset.t !== n2) { paint(b, n2); b.dataset.t = n2; }
    }
    function loop(now) {
      requestAnimationFrame(loop);
      var dt = Math.min(.05, (now - last) / 1000); last = now;
      if (!vis) return;
      cool -= dt;
      if (cool <= 0) {
        morph -= cool; cool = 0;
        var f = morph / MT;
        if (f >= 1) { f = 1; cool = CT; }
        set(f);
        if (f === 1) idx = (idx + 1) % nText;
      } else {
        morph = 0;
        b.style.filter = 'none'; b.style.opacity = '100%'; a.style.filter = 'none'; a.style.opacity = '0%';
      }
    }
    requestAnimationFrame(loop);
  }

  /* ---------- Scroll-driven scenes ---------- */
  var hero = $('#hero'), still = $('#still'), wordL = $('#wordL'), wordR = $('#wordR'), heroFoot = $('#heroFoot');
  var story = $('#story'), storyWords = $$('[data-w]');
  var hSec = $('#hScroll'), track = $('#track'), prog = $('#prog');
  var letterSec = $('#letters'), letterCap = $('#letterCap');
  var collage = $('#collage'), cut = $('#cut'), stackRoot = $('[data-stack-root]'), look = $('#look'), buy = $('#buy');

  function tick() {
    var vh = innerHeight, vw = innerWidth, wide = isWide();
    var r, p;

    if (letterSec && !wide) {
      r = letterSec.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) {
        p = clamp((HEADER - r.top) / (letterSec.offsetHeight - (vh - HEADER)));
        var n = letterCaps.length, seg = p * (n - 1);
        var ez = function (x) { return 1 - Math.pow(1 - clamp(x), 3); };
        $$('[data-letter]', letterSec).forEach(function (el) {
          var i = +el.dataset.letter;
          if (i === 0 && reduce) return;
          var inP = i === 0 ? 1 : ez((seg - (i - 1)) / 0.85);
          var depth = Math.max(0, seg - i);
          var s = 1 - Math.min(depth, 2) * 0.06;
          var rot = (i % 2 ? 3 : -3) * (1 - inP) + (i === 0 ? -2 : i % 2 ? 2.5 : -1.5) * Math.min(depth, 1);
          el.style.transform = reduce ? (inP > .5 ? 'none' : 'translate3d(0,120vh,0)') : 'translate3d(' + (-depth * 4) + '%, ' + ((1 - inP) * 115) + 'vh, 0) scale(' + s + ') rotate(' + rot + 'deg)';
          el.style.filter = depth > 0.05 ? 'brightness(' + (1 - Math.min(depth, 1) * 0.12) + ')' : '';
        });
        var act = Math.min(n - 1, Math.round(seg));
        $$('[data-letterdot]', letterSec).forEach(function (d) {
          var on = +d.dataset.letterdot === act;
          d.style.width = on ? '22px' : '6px';
          d.style.background = on ? '#C3001A' : 'rgba(30,26,23,.25)';
        });
        if (letterCap) letterCap.textContent = letterCaps[act] || '';
      }
    }

    if (hero) {
      r = hero.getBoundingClientRect();
      var heroP = clamp((HEADER - r.top) / (hero.offsetHeight - (vh - HEADER)));
      if (!reduce && r.bottom > 0) {
        if (still) {
          var stage = still.parentElement;
          var shell = still.closest('.mr-hero-frame') || stage;
          if (!still.dataset.cssW) still.dataset.cssW = still.style.width;
          if (still.dataset.vw !== String(vw)) {
            still.style.transform = 'none';
            still.style.marginLeft = '0';
            still.style.marginTop = '0';
            still.style.width = still.dataset.cssW;
            still.style.height = '';
            still.style.left = '';
            still.style.top = '';
            still.dataset.baseW = String(still.offsetWidth);
            still.dataset.baseH = String(still.offsetHeight);
            still.dataset.vw = String(vw);
          }
          var baseW = +still.dataset.baseW;
          var baseH = +still.dataset.baseH;
          if (baseW > 2 && baseH > 2 && shell && stage) {
            var fw = shell.clientWidth;
            var fh = shell.clientHeight;
            var startLeft = (stage.clientWidth - baseW) / 2;
            var startTop = (stage.clientHeight - baseH) / 2;
            var cx = startLeft + baseW / 2;
            var cy = startTop + baseH / 2;
            var frameLeft = -stage.offsetLeft;
            var frameTop = -stage.offsetTop;
            var needW = 2 * Math.max(cx - frameLeft, frameLeft + fw - cx);
            var needH = 2 * Math.max(cy - frameTop, frameTop + fh - cy);
            var cover = Math.max(needW / baseW, needH / baseH);
            var e = heroP * heroP;
            var z = 1 + e * Math.max(0, cover - 1);
            var w = baseW * z;
            var h = baseH * z;
            still.style.marginLeft = '0';
            still.style.marginTop = '0';
            still.style.transform = 'none';
            still.style.left = (cx - w / 2) + 'px';
            still.style.top = (cy - h / 2) + 'px';
            still.style.width = w + 'px';
            still.style.height = h + 'px';
            var pic = still.querySelector('img');
            if (pic) {
              pic.style.position = 'absolute';
              pic.style.inset = '0';
              pic.style.maxWidth = 'none';
              pic.style.maxHeight = 'none';
              pic.style.width = '100%';
              pic.style.height = '100%';
              pic.style.objectFit = 'cover';
              pic.style.left = '0';
              pic.style.top = '0';
              pic.style.right = '0';
              pic.style.bottom = '0';
            }
          }
        }
        if (wordL) wordL.style.transform = 'translate3d(' + (-heroP * 70) + 'vw,0,0)';
        if (wordR) wordR.style.transform = 'translate3d(' + (heroP * 70) + 'vw,0,0)';
        if (heroFoot) heroFoot.style.opacity = String(1 - clamp(heroP * 3));
      }
    }

    if (story) {
      r = story.getBoundingClientRect();
      p = reduce ? 1 : clamp((vh * 0.8 - r.top) / (r.height * 0.72));
      var wn = storyWords.length;
      storyWords.forEach(function (w, i) { w.style.opacity = (i + 1) / wn <= p + 0.02 ? '1' : '0.16'; });
    }

    if (hSec && track) {
      r = hSec.getBoundingClientRect();
      p = clamp((HEADER - r.top) / (hSec.offsetHeight - (vh - HEADER)));
      track.style.transform = 'translate3d(' + (-p * Math.max(0, track.scrollWidth - vw)) + 'px,0,0)';
      if (prog) prog.style.width = (p * 100) + '%';
    }

    if (collage && !reduce) {
      r = collage.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) {
        var off = r.top + r.height / 2 - vh / 2;
        $$('[data-speed]', collage).forEach(function (el) { el.style.transform = wide ? 'translate3d(0, ' + (off * +el.dataset.speed) + 'px, 0)' : 'none'; });
      }
    }

    if (cut && !reduce) {
      r = cut.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh) {
        p = clamp((vh - r.top) / (vh * 0.9));
        $$('[data-cut]', cut).forEach(function (el) {
          var x = (+el.dataset.cut) * (1 - p) * 60;
          el.style.transform = Math.abs(x) > 0.4 ? 'translate3d(' + x + 'vw,0,0)' : 'none';
        });
      }
    }

    if (stackRoot && !reduce) {
      var cards = $$('[data-stack]', stackRoot);
      cards.forEach(function (c, i) {
        var inner = c.firstElementChild, nx = cards[i + 1], sp = 0;
        if (nx) {
          var top = parseFloat(getComputedStyle(c).top) || 72;
          sp = clamp((vh - nx.getBoundingClientRect().top) / (vh - top));
        }
        inner.style.transform = sp > 0.01 ? 'scale(' + (1 - sp * 0.06) + ')' : 'none';
        inner.style.filter = sp > 0 ? 'brightness(' + (1 - sp * 0.35) + ')' : '';
      });
    }

    if (look && !document.getElementById('lookA')) {
        r = look.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) {
          p = reduce ? 1 : clamp((HEADER - r.top) / Math.max(1, look.offsetHeight - (vh - HEADER)));
          var m = function (a, b, x) { return clamp((x - a) / (b - a)); };
          var ez3 = function (x) { return 1 - Math.pow(1 - x, 3); };
          var g = $('[data-gal]', look);
          if (g) {
            var rot = 75 * (1 - ez3(m(0, .5, p)));
            var sc = 1.2 - .2 * ez3(m(.5, .9, p));
            if (rot < 0.5 && sc > 0.995) {
              g.style.transform = 'none';
              g.style.transformStyle = 'flat';
            } else {
              g.style.transformStyle = 'preserve-3d';
              g.style.transform = 'rotateX(' + rot + 'deg) scale(' + sc + ')';
            }
          }
          var H = vh - HEADER, q = m(.25, 1, p);
          $$('[data-gcol]', look).forEach(function (c) {
            var travel = Math.max(0, c.offsetHeight - H * 0.95);
            var k = +c.dataset.gcol === 1 ? 1 - q : q;
            c.style.transform = 'translate3d(0, ' + (-travel * k) + 'px, 0)';
          });
        }
    }

    if (buy && hero) {
      var br = buy.getBoundingClientRect();
      var inBuy = br.top < vh * 0.6 && br.bottom > 120;
      var themeFooter = document.querySelector('.footer-group');
      var inFooter = themeFooter && themeFooter.getBoundingClientRect().top < vh * 0.92;
      var st = hero.getBoundingClientRect().bottom < vh * 0.5 && !inBuy && !inFooter;
      if (st !== state.sticky) { state.sticky = st; renderSticky(); }
    }
  }

  var rafId = null;
  function onScroll() { if (!rafId) rafId = requestAnimationFrame(function () { rafId = null; tick(); }); }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);

  /* ---------- Gallery ---------- */
  var galImgs = [], galDots = [], galThumbs = [], nImg = 0;
  var stickyShot = $('#stickyShot');
  function pickGallery(sel) {
    return $$(sel).filter(function (el) { return !el.dataset.gallery || el.dataset.gallery === state.gender; });
  }
  function syncGallery() {
    $$('[data-gi], [data-gd], [data-gt]').forEach(function (el) {
      if (!el.dataset.gallery) return;
      el.hidden = el.dataset.gallery !== state.gender;
    });
    galImgs = pickGallery('[data-gi]');
    galDots = pickGallery('[data-gd]');
    galThumbs = pickGallery('[data-gt]');
    nImg = galImgs.length;
    if (state.img >= nImg) state.img = 0;
    var thumbImg = galThumbs[0] && galThumbs[0].querySelector('img');
    if (stickyShot && thumbImg) stickyShot.src = thumbImg.src;
  }
  function renderGallery() {
    galImgs.forEach(function (el, i) { var on = i === state.img; el.style.opacity = on ? '1' : '0'; el.style.transform = on ? 'none' : 'scale(1.06)'; });
    galDots.forEach(function (el, i) { var on = i === state.img; el.style.width = on ? '18px' : '4px'; el.style.background = on ? '#1E1A17' : 'rgba(30,26,23,.25)'; });
    galThumbs.forEach(function (el, i) { var on = i === state.img; el.style.boxShadow = on ? '0 0 0 2px #1E1A17' : 'inset 0 0 0 1px rgba(30,26,23,0.1)'; el.style.opacity = on ? '1' : '0.7'; });
  }
  syncGallery();
  renderGallery();
  var galPrev = $('#galPrev'), galNext = $('#galNext');
  if (galPrev) galPrev.addEventListener('click', function () { if (!nImg) return; state.img = (state.img - 1 + nImg) % nImg; renderGallery(); });
  if (galNext) galNext.addEventListener('click', function () { if (!nImg) return; state.img = (state.img + 1) % nImg; renderGallery(); });
  $$('[data-gt]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (t.hidden) return;
      state.img = galThumbs.indexOf(t);
      if (state.img < 0) state.img = 0;
      renderGallery();
    });
  });

  /* ---------- Buy box ---------- */
  var sizeGrid = $('#sizeGrid'), sizeLabel = $('#sizeLabel'), sizeError = $('#sizeError');
  var ctaBtn = $('#ctaBtn'), ctaLabel = $('#ctaLabel'), genderPill = $('#genderPill');
  var badge = $('#cartBadge'), toast = $('#toast');
  var stickyBar = $('#stickyBar'), stickyCta = $('#stickyCta');

  var variantSets = { Men: [], Women: [] };
  try {
    var variantNode = document.getElementById('mrVariants');
    if (variantNode) variantSets = JSON.parse(variantNode.textContent);
  } catch (err) {}
  function compactSize(label) { return String(label || '').replace(/\s+/g, ''); }
  function sizesFor(gender) {
    var list = variantSets[gender];
    if (list && list.length) return list;
    return (sizeSets[gender] || []).map(function (l) { return { id: null, label: l, available: true }; });
  }

  var sizeChart = document.getElementById('sizeChart');
  var sizeGuide = document.getElementById('GlSizeGuide-manik');
  if (sizeGuide && sizeGuide.parentElement !== document.body) document.body.appendChild(sizeGuide);
  if (sizeChart) sizeChart.addEventListener('click', function (e) {
    e.preventDefault();
    if (!sizeGuide) return;
    var tab = sizeGuide.querySelector('[data-gl-sg-gender="' + (state.gender === 'Women' ? 'women' : 'men') + '"]');
    if (tab) tab.click();
    if (typeof sizeGuide._glOpen === 'function') sizeGuide._glOpen();
  });

  function setGender(g) { state.gender = g; state.size = null; state.variantId = null; state.img = 0; syncGallery(); renderGallery(); renderBuy(); }
  $$('[data-gender]').forEach(function (b) { b.addEventListener('click', function () { setGender(b.dataset.gender); }); });
  $$('[data-sg]').forEach(function (b) { b.addEventListener('click', function () { setGender(b.dataset.sg); }); });

  function renderSizes() {
    if (!sizeGrid) return;
    sizeGrid.innerHTML = '';
    sizesFor(state.gender).forEach(function (v) {
      var label = compactSize(v.label);
      var on = state.variantId === v.id && state.size === label;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'size-btn';
      b.textContent = label;
      b.disabled = !v.available;
      b.style.cssText = 'height:46px; border-radius:6px; border:1px solid ' + (on ? '#1E1A17' : (state.sizeError ? '#C3001A' : 'rgba(30,26,23,0.1)')) + '; background:' + (on ? '#1E1A17' : 'rgba(30,26,23,0.024)') + '; color:' + (on ? '#F5F4EE' : '#1E1A17') + '; font-size:13px; cursor:' + (v.available ? 'pointer' : 'not-allowed') + '; padding:0; opacity:' + (v.available ? '1' : '.35') + '; text-decoration:' + (v.available ? 'none' : 'line-through') + ';';
      b.addEventListener('click', function () {
        if (!v.available) { flash(label + ' is sold out.'); return; }
        state.size = label; state.variantId = v.id; state.sizeError = false; renderBuy();
      });
      sizeGrid.appendChild(b);
    });
  }

  function renderSticky() {
    stickyBar.style.transform = state.sticky ? 'translate(-50%, 0)' : 'translate(-50%, 140%)';
    stickyBar.style.opacity = state.sticky ? '1' : '0';
    $$('[data-sg]').forEach(function (b) {
      var on = b.dataset.sg === state.gender;
      b.style.background = on ? 'linear-gradient(180deg,#FFFFFF,#E4E1D8)' : 'transparent';
      b.style.color = on ? '#1E1A17' : 'rgba(245,244,238,.85)';
      b.style.boxShadow = on ? '0 2px 6px rgba(0,0,0,.3)' : 'none';
    });
    stickyCta.style.background = state.added ? 'linear-gradient(180deg,#F2C00F,#D9A900)' : 'linear-gradient(180deg,#FFFFFF,#DEDBD2)';
    stickyCta.textContent = state.added ? 'Added ✓' : 'Add to cart';
  }

  function renderBuy() {
    genderPill.style.transform = state.gender === 'Men' ? 'translateX(0)' : 'translateX(calc(100% + 6px))';
    $$('[data-gender]').forEach(function (b) { b.style.color = b.dataset.gender === state.gender ? '#F5F4EE' : '#1E1A17'; });
    sizeLabel.textContent = state.size ? state.gender + ' ' + state.size : 'Select';
    sizeError.style.display = state.sizeError ? 'block' : 'none';
    renderSizes();
    ctaLabel.textContent = state.added ? 'Added to cart ✓' : (state.size ? 'Add to cart' : 'Select a size');
    ctaBtn.style.background = state.added ? '#C66933' : '#1E1A17';
    renderSticky();
  }

  function scrollToBuy() { window.scrollTo({ top: buy.getBoundingClientRect().top + scrollY - HEADER, behavior: 'smooth' }); }
  $$('[data-go-buy]').forEach(function (b) { b.addEventListener('click', scrollToBuy); });

  var toastT, addedT;
  function flash(text) {
    clearTimeout(toastT);
    toast.textContent = text;
    toast.style.opacity = '1'; toast.style.transform = 'translate(-50%, 0)';
    toastT = setTimeout(function () { toast.style.opacity = '0'; toast.style.transform = 'translate(-50%, 12px)'; }, 1900);
  }

  function pulseBadge(count) {
    if (!badge) return;
    badge.textContent = String(count);
    badge.style.background = '#C3001A'; badge.style.transform = 'scale(1.45)';
    setTimeout(function () { badge.style.background = '#1E1A17'; badge.style.transform = 'scale(1)'; }, 260);
  }
  function add() {
    if (!state.size || !state.variantId) {
      state.sizeError = true; renderBuy();
      if (sizeGrid) { sizeGrid.style.animation = 'none'; void sizeGrid.offsetWidth; sizeGrid.style.animation = 'mr-shake 320ms linear'; }
      scrollToBuy(); return;
    }
    if (state.adding) return;
    state.adding = true;
    state.sizeError = false;
    if (ctaLabel) ctaLabel.textContent = 'Adding…';
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var data = new FormData();
    data.append('id', String(state.variantId));
    data.append('quantity', '1');
    if (sections.length) {
      data.append('sections', sections);
      data.append('sections_url', window.location.pathname);
    }
    var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url : '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    }).then(function (r) { return r.json(); }).then(function (parsed) {
      if (parsed && parsed.status) {
        state.adding = false;
        flash(parsed.description || parsed.message || 'Could not add this size.');
        renderBuy();
        return;
      }
      var cartUrl = (window.theme && theme.routes && theme.routes.cart_url) ? theme.routes.cart_url : '/cart.js';
      var fetchCfg = (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig('json', 'GET') : { method: 'GET', headers: { 'Accept': 'application/json' } };
      return fetch(cartUrl, fetchCfg).then(function (r) { return r.json(); }).then(function (cart) {
        if (parsed && parsed.sections) cart.sections = parsed.sections;
        if (window.theme && theme.pubsub && theme.pubsub.publish) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'manik', productVariantId: String(state.variantId), cart: cart });
        }
        pulseBadge(cart.item_count);
        state.cart = cart.item_count;
        state.added = true;
        state.adding = false;
        renderBuy();
        var drawer = document.getElementById('CartDrawer');
        if (drawer && typeof drawer.show === 'function') drawer.show(ctaBtn);
        clearTimeout(addedT);
        addedT = setTimeout(function () { state.added = false; renderBuy(); }, 1600);
      });
    }).catch(function () {
      state.adding = false;
      flash('Could not add to cart.');
      renderBuy();
    });
  }
  if (ctaBtn) ctaBtn.addEventListener('click', add);
  if (stickyCta) stickyCta.addEventListener('click', add);

  if (nImg) renderGallery();
  if (sizeGrid && ctaBtn) renderBuy();
  setTimeout(setupReveal, 30);
  setTimeout(startMorph, 60);
  tick();
})();
